export default "/images/vendor/flag-icon-css/flags/4x3/ht.svg?7979dcf65e35682bcb8caf203a52e498";